
















































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { required } from 'vuelidate/lib/validators';
import DropdownLight from '@/shared/dropdown-light/dropdown-light.vue';

@Component({
  components: {
    ...UUIFComponent,
    DropdownLight,
  },
  validations: {
    dataCenter: { required },
  },
})
export default class CloudTenantList extends SwExtendedVue {
  @Prop()
  showDataCenterDialog: boolean;
  dataCenter: string = '';
  @Prop()
  dcOptions: any[];
  submitted: boolean = false;
  errorMessage: string = '';
  closeDialog() {
    console.warn('request');
    this.$emit('closeCLoudTenantListDialog', { datacenter: '' });
  }
  created() {
    this.dataCenter = this.dcOptions[0].id;
    console.warn(this.dataCenter);
  }
  validateForm() {
    this.submitted = true;
    this.errorMessage = '';
    this.$v.$touch();
    if (this.$v.$invalid) {
    } else {
      this.$emit('closeCLoudTenantListDialog', { datacenter: this.dataCenter });
    }
  }
  setDC(dc: string) {
    this.dataCenter = dc;
    this.errorMessage = '';
  }
}
